import React from 'react';
import { Table } from 'antd';
import PropTypes from 'prop-types';
import { tooltipStyle, tooltip, cellWidth, tooltipClick, ImgCell } from '@/components/TableCell';
import styles from './TableList.module.scss';
import { MainTableFields as tf, TextType, TableAction as tac } from '../../types';
import { TableActionType as ta } from '@/util/enum';

class TableList extends React.Component {

    _takeColumns = () => ([
        {
            title: '标题',
            dataIndex: tf.title,
            key: tf.title,
            align: 'center',
            onCell: tooltipStyle,
            render: (text, record) => tooltipClick(text, () => {
                this.props.tableAction(record.id, tac.title, record);
            })
        },
        {
            title: '使用位置',
            dataIndex: tf.position,
            key: tf.position,
            width: cellWidth.big,
            align: 'center',
            onCell: tooltipStyle,
            render: ImgCell
        },
        {
            title: '文本类型',
            dataIndex: tf.type,
            key: tf.type,
            width: cellWidth.normal,
            align: 'center',
            render: (text) => tooltip(TextType[text])
        },
        {
            title: '操作',
            dataIndex: 'action',
            key: 'action',
            width: cellWidth.big,
            align: 'center',
            render: (text, item) => this._renderActionCell(item.id, item)
        }
    ]);

    _renderActionCell = (key, item) => {
        return (
            <div className={styles.action}>
                <div className={styles.item} onClick={() => this.props.tableAction(key, ta.edit, item)}>编辑</div>
            </div>
        );
    }

    render() {
        return (
            <div className={styles.tableContainer}>
                <Table
                    rowClassName={(record, index) => index % 2 === 0 ? '' : styles.tdcolor}
                    rowKey={(record) => record.id}
                    columns={this._takeColumns()}
                    dataSource={this.props.renderData}
                    pagination={false}
                    scroll={{ y: true }}
                />
            </div>
        );
    }
}

TableList.propTypes = {
    renderData: PropTypes.array.isRequired, // 表格数据源
    tableAction: PropTypes.func.isRequired, // 表格操作
    paginationChange: PropTypes.func.isRequired, // 分页操作
};

export default TableList;